<p-table [columns]="columns" [value]="data">
    <ng-template pTemplate="header">
        <tr>
            @for (col of columns; track col.field) {
            <th>{{ col.header | i18next }}</th>
            }
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row let-columns="columns">
        @if (customRowTemplate) {
        <ng-container *ngTemplateOutlet="customRowTemplate; context: { $implicit: row, columns: columns}">
        </ng-container>
        } @else {
        <tr>
            @for (col of columns; track col.field) {
            <td>
                {{ row[col.field] | i18next }}
            </td>
            }
        </tr>
        }
    </ng-template>
</p-table>